import {IAbstractModule, IModuleType} from "@/model/Locker/IModule";

export const ModuleZMaster3A: IAbstractModule = {
  type: IModuleType.masterZ3,
  name: 'Z Master 3 A',
  hasScreen: true,
  columns: [
    [
      {
        name: "1",
        connector: "1",
        cell_size_id: 2,
        accessible: false,
      },
      {
        name: "2",
        connector: "2",
        cell_size_id: 4,
        accessible: false,
      },
      {
        name: "3",
        connector: "3",
        cell_size_id: 4,
        accessible: true,
      },
    ],
  ]
};
